import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { PropType } from "vue";
import ConfirmationComponent from "@/builder/components/form/ConfirmationComponent.vue";
import { AllComponents } from "@/builder/client/AllComponents";
import { IConfirmationComponent } from "./FormInterface";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationRenderContainer',
  props: {
    component: {
        type: Object as PropType<IConfirmationComponent>,
        required: true
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ConfirmationComponent, null, {
    children: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.components, (item) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[item.type]), {
          key: item.id,
          component: item
        }, null, 8, ["component"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})